import React from 'react'
import {useLocation} from 'react-router-dom'
import {MembersLeaveBucketPageLocationState} from '../../../Props/MembersLeaveBucketPageLocationStates'
import {MBMemberError} from '../../../Common/MBMemberError'
import {ExternalLinkButton} from '../../Atoms/Buttons'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import StepGuide from '../../Molecules/StepGuide/StepGuide'
import {ContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {ContentTitle} from '../../Molecules/BaseContentBlocks/ContentTitle'
import {ContentTopMessage} from '../../Molecules/BaseContentBlocks/ContentTopMessage'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {useTranslation} from 'react-i18next'

export const MembersLeaveBucketCompletePage: React.VFC = () => {
  const {t} = useTranslation('member')
  const location = useLocation<MembersLeaveBucketPageLocationState>()
  const locationState: MembersLeaveBucketPageLocationState = location.state

  if (isInvalidLocationState(locationState)) {
    throw new MBMemberError('InvalidOperation')
  }

  const {bucketInfo} = locationState

  return (
    <MembersPageTemplate
      hideFooterNavi={true}
      bucketInfo={bucketInfo}
    >
      <PageTitle>{`${bucketInfo?.name}退会完了`}</PageTitle>

      <StepGuide activity={'leave'} current={'complete'}/>

      <ContentBlock data-testid={'block-notification'}>
        <ContentTitle>
          {`${bucketInfo?.name}退会手続き完了`}
        </ContentTitle>
        <ContentTopMessage
          note={`現在の契約期間満了後に${bucketInfo?.name}退会となります。`}
        >
          ご登録されているメールアドレスに完了通知を送信しました。<br/>
          {t('退会完了.メッセージ')}
        </ContentTopMessage>
      </ContentBlock>

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <ExternalLinkButton
            label={`${bucketInfo?.fcMyPageInfo.name ?? ''}に移動する`}
            url={bucketInfo?.fcMyPageInfo.url}
          />
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}

const isInvalidLocationState = (
  locationState: MembersLeaveBucketPageLocationState,
): boolean => {
  if (!locationState) {
    return true
  }
  if (!locationState.bucketInfo) {
    return true
  }
  if (!locationState.bucketLeave) {
    return true
  }
  if (!locationState.bucketInfo.name) {
    return true
  }
  return false
}
